<template>
  <main-layout>
    <div v-if="!(this.powerListCheck(this.allPower).allPowerCheck)">
      <el-alert
        title="您无权查看本页面。"
        type="warning"
        show-icon
        :closable="false"
      />
    </div>
    <div
      class="pages"
      v-loading="loading"
      v-if="this.powerCheck('获取内容列表')"
    >
      <el-card class="box-card">
        <div class="title_ctrlCol">
          <div class="title_searchCol">
            <div class="title_searchCol_input">
              <el-input
                v-model="searchText"
                placeholder="请输入搜索内容"
                size="small"
              ></el-input>
            </div>
            <div class="title_searchCol_button">
              <el-button
                type="primary"
                size="small"
                @click="this.getData"
              >搜索</el-button>
            </div>
          </div>
          <div class="title_functionCol">
            <div class="title_searchCol_button">
              <el-button
                type="primary"
                size="small"
                @click="this.addVisible = true"
                v-if="this.powerCheck('添加内容')"
              >新增内容</el-button>
            </div>
          </div>
        </div>
        <div class="title_table">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              label=" "
              width="80"
            >
              <template #default="scope">
                <span style="margin-left: 10px">{{ ((this.pageNum - 1) * this.pageSize) + (scope.$index + 1) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="内容标题"
            />
            <el-table-column
              prop="publisher"
              label="创建人"
            />
            <el-table-column label="发布日期">
              <template #default="scope">
                {{ moment(scope.row.pubDate*1000).format('YYYY-MM-DD') }}
                <br />
                {{ moment(scope.row.pubDate*1000).format('HH:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
            >
              <template #default="scope">
                <el-tag
                  class="conteneTagChange"
                  v-if="scope.row.status == 1"
                  @click="this.changeStatus(scope.$index)"
                >待审核</el-tag>
                <el-tag
                  class="conteneTagChange"
                  type="warning"
                  v-if="scope.row.status == 2"
                  @click="this.changeStatus(scope.$index)"
                >审核不通过</el-tag>
                <el-tag
                  class="conteneTagChange"
                  type="success"
                  v-if="scope.row.status == 3"
                  @click="this.changeStatus(scope.$index)"
                >审核通过</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="阅读量"
              prop="visits"
            />
            <el-table-column
              prop="address"
              label="操作"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="this.startEdit(scope.row.id)"
                  v-if="this.powerCheck('编辑内容详情')"
                >编辑</el-button>
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  icon="el-icon-info"
                  iconColor="red"
                  title="确定删除吗？"
                  @confirm="this.delete(scope.row.id)"
                >
                  <template #reference>
                    <el-button
                      type="danger"
                      size="small"
                      v-if="this.powerCheck('删除内容')"
                    >删除</el-button>
                  </template>
                </el-popconfirm>
              </template>

            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="this.sizeChange"
            @current-change="this.pageChange"
            :current-page="this.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="this.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="this.total"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
    <AddContent
      :isVisible="this.addVisible"
      @closeAct="this.closeAdd"
      @addSuccess="this.addSuccess"
    />
    <EditContent
      :isVisible="this.editVisible"
      :editTitleID="this.editIdx"
      @closeAct="this.closeEdit"
      @editSuccess="this.editSuccess"
    />
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/Main.vue";
import AddContent from "./addContent.vue";
import EditContent from "./editContent.vue";
import { powerCheck, powerListCheck } from "@/tools/util";
import { ax } from "@/service/http";
import { ElMessage } from "element-plus";
import moment from "moment";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      total: 1,
      loading: false,
      allPower: ["获取内容列表"],
      addVisible: false,
      editVisible: false,
      editIdx: 0,
      tableData: [],
      searchText: "",
    };
  },
  loading: false,
  components: {
    MainLayout,
    AddContent,
    EditContent,
  },
  created() {
    this.getData();
    // this.getQiniuToken();
  },
  methods: {
    moment,
    powerCheck,
    powerListCheck,
    changeStatus(idx) {
      console.log(idx);
      console.log(this.tableData[idx].id);
      console.log(this.tableData[idx].status);
      let newStatus = 3;
      if (this.tableData[idx].status == 3) {
        newStatus = 2;
      }
      ax("changeContentStatus", {
        data: { status: newStatus },
        urlParam: { id: this.tableData[idx].id },
      })
        .then(() => {
          let newTableData = [...this.tableData];
          newTableData[idx].status = newStatus;
          this.tableData = newTableData;
          ElMessage.success({
            message: "状态变更完成",
            type: "success",
          });
        })
        .catch((e) => {
          ElMessage.error({
            message: e.msg,
            type: "error",
          });
        });
    },
    startAdd() {
      this.addVisible = true;
    },
    closeAdd() {
      this.addVisible = false;
    },
    addSuccess(newData) {
      console.log(newData);
      this.tableData = [newData, ...this.tableData];
      this.addVisible = false;
    },
    startEdit(idx) {
      console.log(idx);
      this.editIdx = idx;
      this.editVisible = true;
    },
    closeEdit() {
      this.editVisible = false;
    },
    editSuccess(newData) {
      console.log(newData);
      let newTableData = [...this.tableData];
      for (let i in newTableData) {
        if (newData.id == newTableData[i].id) newTableData[i] = newData;
      }
      this.tableData = newTableData;
      this.editVisible = false;
    },
    delete(id) {
      console.log(id);
      ax("deleteContent", { urlParam: { id } })
        .then(() => {
          let newTableData = [];
          for (let i in this.tableData) {
            if (id != this.tableData[i].id)
              newTableData.push(this.tableData[i]);
          }
          this.tableData = newTableData;
          ElMessage.success({
            message: "内容已删除",
            type: "success",
          });
        })
        .catch((e) => {
          ElMessage.error({
            message: e.msg,
            type: "error",
          });
        });
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    pageChange(e) {
      this.pageNum = e;
      this.getData();
    },

    getData() {
      // console.log(e)
      this.loading = true;
      let queryObject = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      console.log(queryObject);
      if (this.searchText != "") {
        queryObject.searchText = this.searchText;
      }
      ax("getContentList", { data: queryObject })
        .then((res) => {
          console.log(res);
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less">
.title_ctrlCol {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.title_chooseSchool,
.title_searchCol {
  flex: 2;
}
.title_searchCol {
  display: flex;
  align-items: center;
}
.title_searchCol_input {
  width: 200px;
}
.title_searchCol_button {
  flex: 1;
  padding-left: 10px;
}
.title_functionCol {
  flex: 2;
  text-align: right;
}
.conteneTagChange {
  cursor: pointer;
}
</style>
